// extracted by mini-css-extract-plugin
export default {"subtitle":"PartnerPage--subtitle--xq_Tu"};